'use client';

import dynamic from 'next/dynamic';

import type { SignInButtonClientProps } from '@/app/components/SignIn/SignInButtonClient';

const SignInButton = dynamic(() => import('./SignInButtonClient'));

type SignInButtonDynamicProps = {
  readonly signInButtonClientProps: SignInButtonClientProps;
};

const SignInButtonDynamic = ({
  signInButtonClientProps,
}: SignInButtonDynamicProps) => {
  return <SignInButton {...signInButtonClientProps} />;
};

export default SignInButtonDynamic;
